export const CONTACT_DEALS_STATUS = {
  LOST: 'lost',
  PAUSED: 'paused',
  CLOSED: 'closed',
  PROJECT: 'project',
  WON: 'won'
}

export const CONTACT_PROPOSAL_STATUS = {
  ACTIVE: 'active',
  WON: 'won',
  LOST: 'lost'
}
